<template>
  <div class="form" :style="{ width: formWidth }">
    <div class="header">
      <slot name="header"></slot>
    </div>

    <section>
      <template v-for="item in formItems">
        <!-- 文本/密码组件 -->
        <div v-if="item.type === 'text' || item.type === 'password'" :key="item.field">
          <form-input
            :itemFormValue="formValue"
            :item="item"
            @value="itemValue"
            @change="itemChange"
          ></form-input>
        </div>

        <!-- 姓名组件 -->
        <div v-if="item.type === 'name'" :key="item.field">
          <form-name
            :itemFormValue="formValue"
            :item="item"
            @value="itemValue"
            @change="itemChange"
          ></form-name>
        </div>

        <!-- 注册姓名组件 -->
        <div v-if="item.type === 'signupname'" :key="item.field">
          <form-name-sign-up2
            :itemFormValue="formValue"
            :item="item"
            @value="itemValue"
            @change="itemChange"
          ></form-name-sign-up2>
        </div>

        <!-- 卡号组件 -->
        <div v-if="item.type === 'card'" :key="item.field">
          <form-card
            :itemFormValue="formValue"
            :item="item"
            @value="itemValue"
            @change="itemChange"
          ></form-card>
        </div>

        <!-- 国家下拉框组件 -->
        <div v-if="item.type === 'select'" :key="item.field">
          <form-country-select v-model:dialCode="dialCode" :areaList="areaList" @value="itemValue">
          </form-country-select>
        </div>

        <!-- 区域号码下拉框组件 -->
        <div v-if="item.type === 'phone'" :key="item.field">
          <form-phone-select
            :itemFormValue="formValue"
            :item="item"
            :areaList="areaList"
            v-model:dialCode="dialCode"
            @value="itemValue"
          >
          </form-phone-select>
        </div>
      </template>
    </section>

    <div class="footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
  import verify from '@/utils/verify';
  import formPhoneSelect from '../../FormPhoneSelect';
  import formCountrySelect from '../../FormCountrySelect';
  import formInput from '../../FormInput';
  import formName from '../../FormName';
  import formCard from '../../FormCard';
  import formNameSignUp2 from '@/components/BaseUi/FormNameSignUp2';

  export default {
    name: 'Form',

    components: {
      formPhoneSelect,
      formCountrySelect,
      formInput,
      formName,
      formCard,
      formNameSignUp2,
    },

    props: {
      formWidth: {
        type: String,
        default: '100%',
      },
      formItems: {
        type: Array,
        default: () => [],
      },
      errMessage: {
        type: Array,
        default: () => [],
      },
      // 用于数据的回填
      formValue: {
        type: Object,
        default: () => {},
      },
    },

    watch: {
      // 如果我什么都没有填写的情况下，获取到当前表单的字段放入到modalValue里
      formItems: {
        handler(newVal) {
          for (const item of newVal) {
            if (item?.children) {
              item.children.forEach(item => {
                if (!this.modalValue[item.field]) {
                  this.modalValue[item.field] = '';
                }
              });
            } else {
              if (!this.modalValue[item.field]) {
                this.modalValue[item.field] = '';
              }
            }
          }
        },
        immediate: true,
      },

      // 点击提交按钮后，获取到所有的校验信息，判断是否需要给对应的item添加错误消息提示
      // TODO: 需要确定下是否跟handleVerify功能是一致的，此处代码是否多余, 后期可以再优化下，统一使用handleVerify的处理方式
      // TODO: 可以处理下verify成功返回的值，加上field字段，以便跟handleVerify的使用保持一致
      errMessage: {
        handler(errMessageArr) {
          this.formItems.forEach(res => {
            // TODO: 临时处理：当用户传入的是空数组，则清空所有的判断
            if (errMessageArr.length === 0) {
              res.errorMsg = '';
              res.errorShow = false;

              if (res?.children?.length) {
                res.children.forEach(item => {
                  item.errorMsg = '';
                  item.errorShow = false;
                });
              }
              return;
            }

            errMessageArr.forEach(errs => {
              if (res.field === errs.name) {
                res.errorMsg = errs.errMessage;
                res.errorShow = true;
              } else if (res?.children?.length) {
                res.children.forEach(item => {
                  if (item.field === errs.name) {
                    item.errorMsg = errs.errMessage;
                    item.errorShow = true;
                  }
                });
              }
            });
          });
        },
        // 首次执行的时候，就会拿到一个errMessageArr为空的数组，可以解决用户切换后没有清除错误信息的问题
        immediate: true,
      },
    },

    data() {
      return {
        // 合并所有表单填写的信息
        modalValue: {},
        areaList: [],
        dialCode: '1',
      };
    },

    mounted() {
      if (
        this.formItems.some(item => {
          return ['select', 'phone'].includes(item.type);
        })
      ) {
        this.getAreaList();
      }
    },

    methods: {
      itemChange(data, field) {
        this.modalValue = { ...this.modalValue, ...data };
        const findCurrentChangeItem = this.formItems.find(item => {
          return item.field === field;
        });
        // 针对FormCard组件
        let findCurrentChangeItemForCardForm1, findCurrentChangeItemForCardForm2;
        if (!findCurrentChangeItem) {
          findCurrentChangeItemForCardForm1 = this.formItems.find(item => {
            return item.hasOwnProperty('children');
          });
          findCurrentChangeItemForCardForm2 = findCurrentChangeItemForCardForm1.children.find(
            item => {
              return item.field === field;
            },
          );
        }
        // 为了解决只有blur才校验的时候，导致有格式报错的时候，点击按钮隐藏报错文本而发生页面回流，无法触发点击事件
        // 解决方法：只要有报错的文本，onChange事件触发时，自动关闭所有校验
        if (findCurrentChangeItem?.errorMsg) {
          findCurrentChangeItem.errorMsg = '';
          findCurrentChangeItem.errorShow = false;
        }
        if (findCurrentChangeItemForCardForm2?.errorMsg) {
          findCurrentChangeItemForCardForm2.errorMsg = '';
          findCurrentChangeItemForCardForm2.errorShow = false;
        }
      },
      itemValue(data, field) {
        this.modalValue = { ...this.modalValue, ...data };
        // 校验获取到的值
        this.handleVerify(field, data[field]);
      },

      // 校验方法
      handleVerify(field, value) {
        verify({ [field]: value ?? '' }).then(res => {
          if (res?.pass) {
            // TODO: 特殊处理,后期看看是否能够再优化
            if (field === 'confirmEmail') {
              this.setItemSetErrorState(this.formItems, 'email', false);
            }
            if (field === 'confirmPassword') {
              this.setItemSetErrorState(this.formItems, 'password', false);
            }

            this.setItemSetErrorState(this.formItems, field, false);

            // 返回给父组件的数据
            if (this.formValue) {
              const changeValue = Object.assign(this.formValue, { [field]: value });
              this.$emit('changeFormValue', changeValue);
            }
          } else {
            res.forEach(err => {
              this.setItemSetErrorState(this.formItems, err.name, true, err.errMessage);
            });
          }
        });
      },

      // 找到对应的item
      setItemSetErrorState(itemArrs, field, errorShow, errorMsg = '') {
        itemArrs.forEach(item => {
          if (item.field === field) {
            item.errorShow = errorShow;
            item.errorMsg = errorMsg;
          }

          if (item?.children && item?.children.length) {
            this.setItemSetErrorState(item.children, field, errorShow, errorMsg);
          }
        });
      },

      // 获取地区数据
      // TODO 留意这个接口为什么不会调用request.js里配置的全局lang
      getAreaList() {
        this.$http.login
          .areaCodeList(localStorage.getItem('lang'))
          .then(res => {
            if (res?.state === '11') {
              this.areaList = Object.freeze(res.list) || [];
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
  @use './index';
  @use './mobile';
</style>
